import React, { useContext, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { get, forOwn } from 'lodash'
import ReactGA from 'react-ga4'
import Countdown from 'react-countdown-now'

// components
import Vote from '../components/Vote'
import Results from '../components/Results'
import MetaTags from '../components/MetaTags'

// styled
import { Button, Container, InfoBox, TimerContainer } from '../components/styled'

// hooks
import usePost from '../hooks/usePost'
import usePostUserVote from '../hooks/usePostUserVote'

// auth
import { AuthContext } from '../auth/AuthContext'

const getPostDescription = (post) => {
  let description = ''
  forOwn(get(post, 'candidates', {}), (candidate, key) => {
    description += `${candidate.name}? `
  })
  return description
}

const QuickPost = () => {
  const navigate = useNavigate()
  const { postulationId: postId } = useParams()

  const { post: postulation, loading: postLoading, error: postError, deletePost } = usePost({ postId, isQuick: true })
  const { vote, loading: voteLoading, saveVote, abstain } = usePostUserVote({ postId, isQuick: true })

  const { user } = useContext(AuthContext)

  useEffect(() => {
    window.previousLocation = window.location.pathname
    ReactGA.send({ hitType: 'pageview', page: `/quickPost${window.location.pathname}` })
  }, [postId])

  const handleDeletePostulation = () => {
    const doDelete = window.confirm('Are you sure you want to delete this post?')

    if (doDelete) {
      deletePost().then(() => {
        // Navigate back to previous page, or home if no history
        navigate(-1)
      }).catch((err) => {
        window.alert('im afraid i cant do that' + err)
      })
    }
  }

  if (postLoading || voteLoading) {
    return <div>Loading</div>
  }

  if (postError) {
    return <div>{postError}</div>
  }

  const closed = postulation.isClosed
  const expired = postulation.isExpired

  return (
    <Container className='App'>
      <MetaTags
        title={`Sortada.com: ${get(postulation, 'title', '')}`}
        description={getPostDescription(postulation)}
        image={postulation.imgUrl}
      />
      {!closed && !expired && <InfoBox>Welcome to Sortada. You can vote on this quick post without logging in.</InfoBox>}
      {postulation.hasExpiration && <TimerContainer><span>Time left: </span><Countdown date={postulation.expires} /></TimerContainer>}
      <h1>{postulation.title}</h1>
      {postulation.id &&
            !vote && !closed && !expired &&
              <Vote isQuick postulation={postulation} vote={vote} saveVote={saveVote} abstain={abstain} deleteFn={handleDeletePostulation} />}
      {closed && !vote && <InfoBox>You're late to the party.  This postulation was closed before you could vote...here's the results</InfoBox>}
      {expired && !vote && <InfoBox>Ooops.  This quick post is over....here's the results</InfoBox>}
      {(vote || closed || expired) && <Results vote={vote} postulation={postulation} />}

      {get(user, 'uid') === postulation.ownerId && (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
          <div style={{ marginBottom: '1em' }}>Owner Options:</div>
          <Button onClick={handleDeletePostulation}>Delete</Button>
        </div>
      )}
    </Container>
  )
}

export default QuickPost
